import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { Table } from 'antd';
import { useMemo } from 'react';
import { renderColumns } from './columns';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTable = styled(Table)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  .ant-table-thead > tr > th {\n    background: ", ";\n  }\n  .ant-table-container table {\n    & > tbody > tr > td {\n      cursor: pointer;\n    }\n  }\n"])), styleVariables.colors.gray3);
export var TableViolateSubmission = function TableViolateSubmission(_ref) {
  var attendeeSubmission = _ref.attendeeSubmission,
      attendeeSubmissionTranslation = _ref.attendeeSubmissionTranslation;

  var _attendeeSubmission$s = _slicedToArray(attendeeSubmission.submissions, 1),
      submission = _attendeeSubmission$s[0];

  var columns = useMemo(function () {
    return renderColumns(attendeeSubmissionTranslation);
  }, [attendeeSubmissionTranslation]);
  return /*#__PURE__*/_jsx(StyledTable, {
    bordered: true,
    dataSource: submission.securityTracings,
    columns: columns,
    pagination: false
  });
};